import React, { useContext } from 'react'
import { ChatIdContext } from '../../store/chat-id-context'
import ChatComponent from '../chatDashboard/ChatComponent'

function ChatComponentWrapper() {
  const {chatId, setChatId} = useContext(ChatIdContext)

    setChatId(localStorage.getItem('chat_Id') ?? null)
  return (
      <ChatComponent user_Type={'user'} />
  )
}
export default ChatComponentWrapper